export default "__VITE_ASSET__CepYC2ex__"